import type { ProductionRun } from "../models";
import { operatorRunTime } from "../operator-run-time";

export function runTimers(run: ProductionRun | null, now: number) {
  const format = (milliseconds: number) => {
    const seconds = Math.max(0, Math.floor(milliseconds / 1_000));
    return [
      Math.floor(seconds / 3_600),
      Math.floor((seconds % 3_600) / 60),
      seconds % 60,
    ]
      .map((part) => String(part).padStart(2, "0"))
      .join(":");
  };
  const effectiveNow =
    run?.status === "COMPLETED" && run.closedAt
      ? new Date(run.closedAt).getTime()
      : now;
  const openedAt = run?.openedAt
    ? new Date(run.openedAt).getTime()
    : Number.NaN;
  const startedAt = run?.startedAt
    ? new Date(run.startedAt).getTime()
    : Number.NaN;
  const actualTime = run ? operatorRunTime(run, effectiveNow) : null;
  const openDowntime = run?.downtimes.find((item) => !item.endedAt);
  const openStartedAt = openDowntime
    ? new Date(openDowntime.startedAt).getTime()
    : Number.NaN;
  return {
    now: effectiveNow,
    production: format(actualTime?.productionMilliseconds ?? 0),
    downtime: format(
      Number.isNaN(openStartedAt) ? 0 : effectiveNow - openStartedAt,
    ),
    waiting: format(
      Number.isNaN(openedAt)
        ? 0
        : Math.max(
            0,
            (Number.isNaN(startedAt) ? effectiveNow : startedAt) - openedAt,
          ),
    ),
  };
}
